import { Badge, Icon } from "@resource/atlas";
import { atlasDragVertical, serviceGreenhouse } from "@resource/atlas/icons";
import { strings } from "@resource/common";
import clsx from "clsx";
import { Draggable } from "react-beautiful-dnd";
import ReactDOM from "react-dom";

import { Stage } from "./GuideTemplateMapper";

interface Props {
  index: number;
  stage: Stage;
  showJobsCount: boolean;
}

function ATSStage({ stage, index, showJobsCount }: Props) {
  return (
    <Draggable draggableId={stage.id} index={index}>
      {(provided, snapshot) => {
        const item = (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            className={clsx(
              "bg-white text-body-md rounded-md border p-3 border-light-gray-500",
              { "bg-light-gray-200 shadow-24": snapshot.isDragging }
            )}
          >
            <div className="flex justify-between items-center">
              <div className="flex overflow-hidden gap-2">
                <Icon
                  className="inline-block text-subtle"
                  content={atlasDragVertical}
                />
                <Icon content={serviceGreenhouse} />
                <span className="overflow-hidden whitespace-nowrap text-ellipsis">
                  {stage.name}
                </span>
              </div>
              {showJobsCount && (
                <Badge>
                  {strings.pluralize(
                    "job",
                    stage.jobRoleGuideTemplateIds.length
                  )}
                </Badge>
              )}
            </div>
          </div>
        );

        if (snapshot.isDragging) {
          /**
           * Doing this due to a bug in dnd library where any of the parent
           * cannot have the transform property set to any value.
           * Ref: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/reparenting.md
           */
          return ReactDOM.createPortal(
            item,
            document.getElementsByTagName("body")[0]
          );
        }
        return item;
      }}
    </Draggable>
  );
}

export default ATSStage;
